<template lang="pug">
  .wrapper-compman-details
    h2 editar dados da empresa
    .form-new
      Validate.name(v-model="name")
        PTextField(
          name="name"
          label="nome da empresa"
          title="Teste"
        )
      Validate.code(v-model="appKey")
        PTextField(
          name="code"
          :label="'código de ativação (ATENÇÃO: ALTERE SOMENTE SE NECESSÁRIO)'"
          type="number"
        )
          template(slot="icon")
            PButton(size="sm" color="primary" @mousedown.prevent.stop="activeModal")
              span.icon-ptt-icons-info.color-primary-contras
      Accordion.configs(:startOpen="true")
        template(slot="heading")
          span.fs-19(style="text-align: center;") configurações da empresa

        template
          .fields
            .active-auth
              PCheckbox(label="Ativação em dois passos para a liberação do ponto pelo computador" v-model="activeAuth")
            .can-lock-folha
              PCheckbox(label="Ativar opção de travar folha" v-model="canLockFolha")
            .verify-observations
              PCheckbox(label="Travar folha apenas se não houver dias incompletos ou com observações" v-model="verifyObservations")
      .button(v-has-permission="{module: 'appkey', action: 'post', hide: true}")
        PButton(color="success", size="md", @click="save", :loading="loading") salvar
</template>

<script>
import { useValidationsMixin } from 'src/common/validations'

export default {
  name: 'CompManDetails',
  async created () {
    try {
      const params = {
        fields: JSON.stringify(['id', 'name', 'app_key', 'active_auth', 'can_lock_folha', 'verify_observations'])
      }
      const result = await this.$API.compManDetail.get(params)
      const compmanDetail = result.body.success
      this.id = compmanDetail.id
      this.name = compmanDetail.name
      this.appKey = compmanDetail.appKey
      this.activeAuth = compmanDetail.activeAuth
      this.canLockFolha = compmanDetail.canLockFolha
      this.verifyObservations = compmanDetail.verifyObservations
    } catch (e) {
      const msg = e.data.error || 'Aconteceu um erro. Tente novamente.'
      this.$swal({
        type: 'error',
        title: 'Atenção',
        text: msg
      })
    }
  },
  data () {
    return {
      id: '',
      name: '',
      appKey: '',
      activeAuth: false,
      canLockFolha: false,
      verifyObservations: false,
      loading: false
    }
  },
  methods: {
    async save () {
      if (!this.isAllValid()) {
        this.displayAllErrors()
        return
      }

      this.loading = true
      const data = {
        edit_name: this.name,
        appKey: this.appKey,
        active_auth: this.activeAuth,
        can_lock_folha: this.canLockFolha,
        verify_observations: this.verifyObservations,
        comp_man: this.id
      }

      try {
        const result = await this.$API.deviceManage.save({}, data)
        this.$swal({
          title: '',
          type: 'success',
          text: result.body.success
        })
      } catch (e) {
        this.$swal({
          type: 'error',
          text: e.data?.error ? e.data.error : 'Não foi possível salvar'
        })
      }
      this.loading = false
    },
    activeModal () {
      this.$swal({
        title: 'Código de ativação',
        html:
          '<br><br> Esse código é utilizado para ativar os dispositivos de registro de ponto e só deve ser alterado se necessário. <br><br>',
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'Ok'
      })
    }
  },
  mixins: [useValidationsMixin({})]
}
</script>

<style lang="scss" scoped>
.wrapper-compman-details {
  display: grid;
  grid-template-rows: min-content auto;
  grid-template-columns: 1fr;

  h2 {
    text-align: center;
  }

  .form-new {
    grid-row: 2;
    margin-bottom: 30px;
    display: grid;
    grid-template-columns: 1fr .5fr;
    grid-column-gap: 30px;
    grid-row-gap: 20px;
    grid-template-areas:
      "name code"
      "configs configs"
      ". button";

    .name { grid-area: name }
    .code { grid-area: code }
    .configs {
      grid-area: configs;

      .fields {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr 1fr auto;
        grid-column-gap: 30px;
        grid-row-gap: 10px;
        align-items: center;
        grid-template-areas:
          "active-auth"
          "can-lock-folha"
          "verify-observations";

        .active-auth { grid-area: active-auth }
        .can-lock-folha { grid-area: can-lock-folha }
        .verify-observations { grid-area: verify-observations }
      }
    }
    .button { grid-area: button; justify-self: end; margin-top: 30px; }
  }
}
</style>
